export default {
  root: '/pricing', // most businesses
  communications: '/pricing/communications', // small businesses - communications plan details
  vault: '/pricing/vault', // vault plan details
  transfer: '/pricing/transfer', // transfer plan details
} as const;
